<!-- THE RUN THREAD (XAT-E-377): the chat is created into this container at runtime, on the thread's own agent. -->
<ng-container #chat></ng-container>
@if (unavailable) {
  <p class="rtc-unavailable">The conversation can't be shown here. Open it in XatBot to continue.</p>
}
